import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { EMPTY_OBJECT, EVENT_LOG_TITLE, EVENT_TYPES } from '../../constants/globalConstants'
import { saveBookingAfterPayment } from '../../redux/actions/paymentActions'
import Loader from '../../components/global/Loader'
import URL from '../../constants/urls'

import ThankYouCard from '../../components/downloadComponents/ThankYouCard'
import Header from '../../components/global/Header'
import Steps from '../../components/global/Steps'
import { getPaymentCardImg } from '../../utils/helper'
import { storeEventLog } from '../../redux/actions/eventLogActions'
import getConfigDetails from '../../services/config'
import queryString from 'query-string'
import useRecaptcha from '../../hooks/useRecaptcha'

function PaymentFails(props) {
	const { dispatch } = props
	const [isLoading, setIsLoading] = useState(true)
	const [paymentResponse, setPaymentResponse] = useState(EMPTY_OBJECT)
	// const [paymentSession, setPaymentSession] = useState(EMPTY_OBJECT)
	// const [eventDetails, setEventDetails] = useState(EMPTY_OBJECT)
	// const [userEvents, setUserEvents] = useState(EMPTY_OBJECT)
	// const [eventType, setEventType] = useState()
	const [paymentStatus, setPaymentStatus] = useState(false)
	const [systemError, setSystemError] = useState(false)
	// const [eventId, setEventId] = useState()
	const [cardType, setCardType] = useState()
	const [cardLastDigits, setCardLastDigits] = useState()
	// const [name, setName] = useState()
	// const [coupon, setCoupon] = useState('')
	const [phone, setPhone] = useState()
	const [Reservation_id, setReservation_id] = useState()
	const [email, setEmail] = useState()

	const [cardLastFour, setCardLastFour] = useState()

	const [cardExpiryYear, setCardExpiryYear] = useState()
	const [cardExpiryMonth, setCardExpiryMonth] = useState()
	const [cardPan, setCardPan] = useState()
	const [userIp, serUserIp] = useState()
	const navigate = useNavigate()
	const [systemErrorMessage, setSystemErrorMessage] = useState('')
	// ===== reCAPTCHA v3 =====
	const { getToken, isReady } = useRecaptcha()
	const recaptchaTokenRef = useRef(null)
	const finalizedRef = useRef(false)
	const [readyToFinalize, setReadyToFinalize] = useState(false)

	// Generate a reCAPTCHA token before recording the failed booking.
	// Never block indefinitely if reCAPTCHA fails to load.
	useEffect(() => {
		let cancelled = false
		const prepareToken = async () => {
			if (isReady) {
				const token = await getToken('after_payment')
				if (cancelled) return
				recaptchaTokenRef.current = token
				setReadyToFinalize(true)
			}
		}
		prepareToken()
		const fallback = setTimeout(() => {
			if (!cancelled) setReadyToFinalize(true)
		}, 6000)
		return () => { cancelled = true; clearTimeout(fallback) }
	}, [isReady, getToken])
	// ===== End reCAPTCHA =====

	useEffect(() => {
		if (!readyToFinalize || finalizedRef.current) return
		finalizedRef.current = true
		window.scrollTo(0, 0)
		let queries = queryString.parse(location.search)



		// const MerchantRef = queryParams.get('MerchantRef')? queryParams.get('MerchantRef'): ''

		// const TxID = queryParams.get('TxID')? queryParams.get('TxID'): ''

		// const AuthorisationCode = queryParams.get('AuthorisationCode')? queryParams.get('AuthorisationCode'): ''

		// const CardType = queryParams.get('CardType')? queryParams.get('CardType'): ''
		setCardType(queries?.CardType)

		// const CardLastDigits = queryParams.get('CardNumberLast4')? queryParams.get('CardNumberLast4'): ''
		setCardLastDigits(queries?.CardNumberLast4)

		// const DSIndicator = queryParams.get('DSIndicator')? queryParams.get('DSIndicator'): ''

		// const SCATransRef = queryParams.get('SCATransRef')? queryParams.get('SCATransRef'): ''

		// const TokenNo = queryParams.get('TokenNo')? queryParams.get('TokenNo'): ''

		const phone = localStorage.getItem('phone')
		setPhone(phone)

		const reservation_id = localStorage.getItem('reservation_id')
		setReservation_id(reservation_id)

		const lastFour = localStorage.getItem('card_pan')
		setCardLastFour(lastFour)

		const name = localStorage.getItem('name')
		// setName(name)

		const email = localStorage.getItem('email')
		setEmail(email)

		const event_type = localStorage.getItem('event_type')
		// setEventType(event_type)		

		// const event_id = localStorage.getItem('event_id')
		// setEventId(event_id)		

		const paymentSession = JSON.parse(localStorage.getItem('paymentSession'))
		// setPaymentSession(paymentSession)

		const eventDetails = JSON.parse(localStorage.getItem(EVENT_TYPES?.EVENT))
		// setEventDetails(eventDetails)

		const card_pan = localStorage.getItem('card_pan')
		setCardPan(card_pan)

		const card_expiry_month = localStorage.getItem('card_date_expiry_month')
		setCardExpiryMonth(card_expiry_month)

		const card_expiry_year = localStorage.getItem('card_date_expiry_year')
		setCardExpiryYear(card_expiry_year)

		const couponFilled = localStorage.getItem('coupon') ? 'Yes' : 'No'

		const couponApplied = localStorage.getItem('couponApplied') ? localStorage.getItem('couponApplied') : 'No'

		const coupon = localStorage.getItem('coupon') ? localStorage.getItem('coupon') : 'NIL'
		// setCoupon(coupon)

		const user_ip = localStorage.getItem('user_ip')
		serUserIp(user_ip)



		const cardLastDigits = localStorage.getItem('card_pan') ? localStorage.getItem('card_pan') : ''

		if (!name || name == '' || !email || email == '' || !event_type || event_type == '' || !eventDetails || eventDetails == '') {
			navigate(URL.HOME)
		}


		const payloadafterPayment = {
			facility_id: getConfigDetails.FACILITY_ID,
			reservation_id: Reservation_id,
			total: paymentSession?.amount,
			TokenNo: queries?.TokenNo,
			AuthorisationCode: queries?.AuthorisationCode,
			rate_id: event_type !== EVENT_TYPES?.EVENT ? eventDetails?.id : '',
			event_id: event_type == EVENT_TYPES?.EVENT ? eventDetails?.id : '',
			event_category_id: (event_type == EVENT_TYPES?.EVENT) ? eventDetails?.event_category_event?.event_category_id : eventDetails?.event_category_id,
			event_type: event_type,
			arrival: event_type == EVENT_TYPES?.EVENT ? eventDetails?.event_arrival : event_type == EVENT_TYPES?.PARTY_PASS ? eventDetails?.all_event[0]?.start_time : eventDetails?.all_event[0]?.start_time,
			is_full_season: (event_type != EVENT_TYPES?.EVENT) ? eventDetails?.is_full_season : '',
			reference: queries?.MerchantRef,
			TxID: queries?.TxID,
			CardType: queries?.CardType,
			CardNumberLast4: cardLastDigits ? cardLastDigits : cardLastDigits,
			payment_status: 'fail',
			recaptcha_token: recaptchaTokenRef.current
		}

		payloadafterPayment.card_pan = cardPan ? cardPan : card_pan ? card_pan : 'NA',
			payloadafterPayment.card_expiry_month = cardExpiryMonth ? cardExpiryMonth : card_expiry_month ? card_expiry_month : 'NA',
			payloadafterPayment.card_expiry_year = cardExpiryYear ? cardExpiryYear : card_expiry_year ? card_expiry_year : 'NA',
			payloadafterPayment.couponFilled = couponFilled ? couponFilled : 'NA',
			payloadafterPayment.couponApplied = couponApplied ? couponApplied : 'NA',
			payloadafterPayment.coupon = coupon ? coupon : 'NA'
		const payload = {
			'error_message': JSON.stringify(payloadafterPayment),
			'event_name': EVENT_LOG_TITLE?.FAILURE,
			'user_ip': userIp ? userIp : 'NA',
			'facility_id': getConfigDetails.FACILITY_ID
		}
		dispatch(storeEventLog(payload)).then(() => {
		}).catch(() => {
		})

		dispatch(saveBookingAfterPayment(payloadafterPayment)).then((res) => {
			if (res?.data && res?.data != '') {
				setPaymentResponse(res?.data)
				setSystemErrorMessage('')
				setIsLoading(false)
				setPaymentStatus(false)
				setSystemError(false)
				localStorage.clear()
			} else {
				setIsLoading(false)
				setSystemErrorMessage(res?.errors?.message)
				setPaymentStatus(false)
				setSystemError(true)
				localStorage.clear()
			}

		}).catch((err) => {
			setIsLoading(false)
			setPaymentStatus(false)
			setSystemError(true)
			setSystemErrorMessage(err?.errors?.message)
			localStorage.clear()

		})
	}, [readyToFinalize])



	return (
		isLoading ? <Loader /> :
			<div>
				<Header />

				<main>
					<Steps
						page='download'
						systemError={systemError}
						paymentStatus={paymentStatus}
					/>

					<ThankYouCard
						systemError={systemError}
						paymentStatus={paymentStatus}
						systemErrorMessage={systemErrorMessage}
						paymentResponse={paymentResponse}
					/>


					{!systemError && <div className="container text-start">
						<div className="row justify-content-center">
							<div className="col-12 col-md-11">
								<hr />
								<h4 className="mb-4" style={{ marginLeft: 'left' }}>Booking Information</h4>
								<div className="row">
									<div className="col-sm-3">
										<small className='fw-bold'>Email Address</small>
										<p>{paymentResponse?.user?.email ? paymentResponse?.user?.email : email}</p>
									</div>
									<div className='col-auto d-none d-sm-block border-start'></div>
									<div className="col col-sm-3">
										<small className='fw-bold'>Phone Number</small>
										<p>{paymentResponse?.user?.phone ? paymentResponse?.user?.phone : phone}</p>
									</div>
									<div className='col-auto d-none d-sm-block border-start'></div>
									<div className="col col-sm-3">
										<small className='fw-bold'>Payment Card </small>
										<p><img src={getPaymentCardImg(paymentResponse?.transaction?.card_type ? paymentResponse?.transaction?.card_type : cardType ? cardType : 'NA')} height="30px" className='me-2' /> {cardLastDigits ? `Ending with ${cardLastDigits}` : cardLastFour ? `Ending with ${cardLastFour}` : ''} </p>
									</div>
								</div>
							</div>
						</div>
					</div>}
				</main>
			</div>
	)
}
PaymentFails.propTypes = {
	dispatch: PropTypes.func,
	data: PropTypes.object,
}

PaymentFails.defaulProps = {
	dispatch: noop,
	data: EMPTY_OBJECT,
}

function mapStateToProps({ peymentReducer }) {
	return {
		data: peymentReducer,
	}
}
export default connect(mapStateToProps)(PaymentFails)
